import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'caremoni-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss'
})
export class CheckboxComponent {
  @Input() style = {};
  @Input() iconStyle = {};
  @Input() value: boolean = false;
  @Input() disabled: boolean = false;
  @Output() onClick = new EventEmitter();

  @Input()  xdpad?: number = -1;
  @Input()  ydpad?: number = -1;
  @Input()  dpad?: number = -1;
  @Input()  tabdpad?: number = -1;
  @Input()  xtabdpad?: number = -1;
  @Input()  ytabdpad?: number = -1;
  @Input()  scaledpad?: number = -1;

  constructor() { }

  handleClick(event: any) {
    if (this.disabled) {
      return;
    }
    
    this.value = !this.value;

    this.onClick.emit(this.value);
  }
}
